/* Heny: cookie banner with localStorage persistence.
   After Accept/Decline/Close — banner is hidden permanently for this browser
   (until user clears site data). Key: heny_cookie_consent. */
const HENY_COOKIE_KEY = 'heny_cookie_consent';

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      init() {
        // Skip entirely if user already responded
        try {
          if (localStorage.getItem(HENY_COOKIE_KEY)) return;
        } catch (e) {}
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.show = true;
          });
          document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));
        }, delay * 1000);
      },
      _save(value) {
        try {
          localStorage.setItem(HENY_COOKIE_KEY, JSON.stringify({
            value: value,
            timestamp: Date.now()
          }));
        } catch (e) {}
      },
      handleAccept() {
        try {
          if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
          }
        } catch (e) { /* never block the close */ }
        this._save('accepted');
        requestAnimationFrame(() => { this.show = false; });
      },
      handleDecline() {
        try {
          if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
          }
        } catch (e) { /* never block the close */ }
        this._save('declined');
        requestAnimationFrame(() => { this.show = false; });
      },
      handleClose() {
        // X dismiss — also persist so banner doesn't reappear
        this._save('dismissed');
        requestAnimationFrame(() => { this.show = false; });
      }
    }));
  });
});
